/**
 * Feature Flag IDs for number-level routing features
 * These IDs correspond to features enabled on individual phone numbers
 */
export const ROUTING_FEATURE_IDS = {
    FAILOVER_ROUTING: 'f5124297-ba38-4ea9-95e4-7184a9e62cd7',
    BRANCH_ROUTING: 'b6624c14-20d6-4469-96bd-eec03a5fbfb0',
};

/**
 * Check if failover routing is enabled for a number
 * @param {string[]} enabledFeatureIDs - Array of enabled feature IDs from number data
 * @returns {boolean} True if failover routing is enabled
 */
export const isFailoverRoutingEnabled = (enabledFeatureIDs) => {
    if (!Array.isArray(enabledFeatureIDs)) return false;
    return enabledFeatureIDs.includes(ROUTING_FEATURE_IDS.FAILOVER_ROUTING);
};

/**
 * Check if branch routing (simultaneous ring) is enabled for a number
 * @param {string[]} enabledFeatureIDs - Array of enabled feature IDs from number data
 * @returns {boolean} True if branch routing is enabled
 */
export const isBranchRoutingEnabled = (enabledFeatureIDs) => {
    if (!Array.isArray(enabledFeatureIDs)) return false;
    return enabledFeatureIDs.includes(ROUTING_FEATURE_IDS.BRANCH_ROUTING);
};
